import { Switch } from '~/components/ui/switch';
import { cn } from '~/utils/cn';

import type { ChartColor } from './experiment-trend-chart';

interface Props {
  color: ChartColor;
  label: string;
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
}

const dotStyles: Record<ChartColor, string> = {
  blue: 'bg-primary',
  green: 'bg-success',
  orange: 'bg-warning',
  red: 'bg-error',
  purple: 'bg-accent-main',
  info: 'bg-info',
};

export function ExperimentSeriesToggle({ color, label, checked, onCheckedChange }: Props) {
  return (
    <label className="border-border bg-muted flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1.5">
      <span className={cn('h-2 w-2 shrink-0 rounded-full', dotStyles[color])} aria-hidden="true" />
      <span className="text-secondary-text text-sm">{label}</span>
      <Switch checked={checked} onCheckedChange={onCheckedChange} aria-label={label} />
    </label>
  );
}
